import Page from "../PublicPage";
import { PersonAddAlt1 } from "@mui/icons-material";
import RegisterForm from "./RegistrationForm";
import {
  getRoute,
  LOGIN,
} from "Infrastructure/config/routesConfig";

function RegisterPage() {
  return (
    <Page
      title={"PUBLIC.title_register"}
      icon={<PersonAddAlt1 fontSize="inherit" />}
      links={getFooterLinks()}
    >
      <RegisterForm />
    </Page>
  );
}

function getFooterLinks() {
  return [
    {
      label: "PUBLIC.link_already_member_login",
      url: getRoute(LOGIN),
    },
  ];
}

export default RegisterPage;
